function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var Stack = /*#__PURE__*/function () {
  function Stack() {
    _classCallCheck(this, Stack);

    this.stack = new Array();
  }

  _createClass(Stack, [{
    key: "pop",
    value: function pop() {
      return this.stack.pop();
    }
  }, {
    key: "push",
    value: function push(item) {
      this.stack.push(item);
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.stack[0];
    }
  }, {
    key: "empty",
    value: function empty() {
      return this.stack.length == 0;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.stack = new Array();
    }
  }]);

  return Stack;
}();